import { render, staticRenderFns } from "./InvoiceSendModal.vue?vue&type=template&id=70af0a60&"
import script from "./InvoiceSendModal.vue?vue&type=script&lang=js&"
export * from "./InvoiceSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports